import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'react-bootstrap5';

export default function Plan({ countSessions, data, onClick }) {
  return (
    <div
      style={{ flexDirection: 'column' }}
      className={`d-flex plan  text-center ${data.promoted ? 'active' : ''} `}
    >
      <div className="count-sessions">
        {countSessions}
        {' '}
        Annual Session
        {countSessions > 1 ? 's' : ''}
      </div>
      <h4 className="price">
        $
        {data.month_price}
      </h4>
      <div className="small">Per Month</div>
      <div className="small">Paid Annually</div>
      <Button className="mt-5" onClick={onClick}>Purchase</Button>
    </div>
  );
}

Plan.propTypes = {
  countSessions: PropTypes.number.isRequired,
  data: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};
